import { loadModules } from 'esri-loader';
import appConfig from '../config/appConfig';

export default class AssetTypes {
  constructor(props) {
    this.props = props;
  }

  async getAssetTypes() {
    const [esriRequest, UniqueValueRenderer, SimpleRenderer] = await loadModules([
      'esri/request',
      'esri/renderers/UniqueValueRenderer',
      'esri/renderers/SimpleRenderer'
    ]);

    const responseData = await esriRequest(this.props.url);

    const responseDataPipeline = await esriRequest(this.props.pipeline);
    const responseDataTransmission = await esriRequest(this.props.transmission);
    const json = responseData.data;
    const jsonPipeline = responseDataPipeline.data;
    const jsonTransmission = responseDataTransmission.data;

    const pipelineRenderer = SimpleRenderer.fromJSON(jsonPipeline.drawingInfo.renderer);
    const transmissionRenderer = SimpleRenderer.fromJSON(jsonTransmission.drawingInfo.renderer);

    const renderer = UniqueValueRenderer.fromJSON(json.drawingInfo.renderer);

    const sortedAssets = [];
    for (var asset in appConfig.assetTypeSortOrder) {
      const uniqueValueInfo = renderer.uniqueValueInfos.find(
        (r) => r.label === appConfig.assetTypeSortOrder[asset]
      );
      if (uniqueValueInfo) {
        if (uniqueValueInfo.value === "Pipeline") {
          uniqueValueInfo.symbol = pipelineRenderer.symbol;
          uniqueValueInfo.id = "asset_pipeline_id";
        }
        if (uniqueValueInfo.value === "Transmission Line") {
          uniqueValueInfo.symbol = transmissionRenderer.symbol;
          uniqueValueInfo.id = "asset_transmission_id";
        }
        sortedAssets.push(uniqueValueInfo);
      }
    }
    return sortedAssets;
  }
}
